<script>	
	import Painel from './Painel.svelte';

	const opcoes = [
		{
			titulo: "Geral", 
			icone: "listar",
			link: "#/projeto/listagem/geral",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Modalidade: MON", 
			icone: "listar",
			link: "#/projeto/listagem/modalidade/MON",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Modalidade: ID", 
			icone: "listar",
			link: "#/projeto/listagem/modalidade/ID",
			perfis: "CETREINA"		
		},
		{ 
			titulo: "Modalidade: EIC", 
			icone: "listar",
			link: "#/projeto/listagem/modalidade/EIC",
			perfis: "CETREINA"
		},
		{
			titulo: "Modalidade: PD",
			icone: "listar",
			link: "#/projeto/listagem/modalidade/PD",
			perfis: "CETREINA"
		}
	];
</script>

<Painel 
	titulo="Opções de Listagem de Projetos" 
	listaFuncionalidades={opcoes}>
</Painel>